import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { reactLocalStorage } from "reactjs-localstorage";
import { Row, Col, Container, Table } from "reactstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { SearchableSelectHookForm } from "../../layout/HookFormInputs";
// import AddEditRequest from "./AddSupplier";
import { useDispatch, useSelector } from "react-redux";

import NoContentFound from "../../common/NoContentFound";
import { useForm, Controller } from "react-hook-form";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { PaginationWrapper } from "../../common/commonPagination";
import {
  addNewAuditPersons,
  deleteAuditPerson,
  fetchAllAuditTrailList,
  getAuditPersonDropdownList,
} from "./actions/index";
import LoaderCustom from "../../common/LoaderCustom";
import Toaster from "../../common/Toaster";
import {
  handleDepartmentHeader,
  searchNocontentFilter,
  setLoremIpsum,
  userDetails,
} from "../../../helper";
import { Drawer } from "@material-ui/core";
import { ApplyPermissionForAuditListing } from ".";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import _ from "lodash";
import { resetStatePagination } from "../../common/Pagination/paginationAction";
import ReactExport from "react-export-excel";
import { Audit_PERSON_EXCEL, Audit_TRAIL_EXCEL } from "../../../config/masterData";
import { defaultPageSize, EMPTY_DATA } from "../../../config/constants";
import DayTime from "../../common/DayTimeWrapper";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const AuditTrail = (props) => {
  const { auditTrailReducer } = useSelector(
    (state) => state?.AuditTrailListReducer
  );
  const state22 = useSelector((state) => state);
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    setValue,
  } = useForm();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [deletedId, setDeletedID] = useState(null);
  const [loader, setloader] = useState(false);
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });
  const [auditPersonDropdownList, setauditPersonDropdownList] = useState([]);
  const userDetail = userDetails();
  const [selectedEmployees, setSelectedEmployees] = useState({
    employeeId: userDetail?.EmployeeId,
    employeeCodeList: [],
  });
  const [oldValue, setOldValue] = useState(null);
  const [newValue, setNewValue] = useState(null);
  const oldData = oldValue ? JSON.parse(oldValue) : null;
  
  const newData = newValue ? JSON.parse(newValue) : null;
  
  const getUsers = async (
    currentPage,
    pageSize,
    sortOrder,
    employeeId,
    fieldName,
    SearchText
  ) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllAuditTrailList({
          current_page: currentPage,
          per_page: pageSize,
          sortOrder: sortOrder,
          EmployeeCode: parseInt(employeeId, 10),
          sortField: fieldName,
          SearchText: SearchText ? SearchText : "",
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
      setOpen(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  const handleEmployeeSelection = (selectedValues) => {
    if (selectedValues && Array.isArray(selectedValues)) {
      // Extract the unique employee codes from the selected values
      const newEmployeeCodes = selectedValues.map((selectedValue) =>
        selectedValue ? parseInt(selectedValue.value, 10) : undefined
      );

      // Set the new employee codes directly in the state
      setSelectedEmployees({
        ...selectedEmployees,
        employeeCodeList: newEmployeeCodes.map((employeeCode) => ({
          employeeCode: employeeCode,
        })),
      });
    } else {
      // Handle the case where selectedValues is not as expected

    }
  };

  useEffect(() => {
    // getAllAuditPersonListData();
    getUsers(1, defaultPageSize, "ASC", 5, "");
  }, []);

  // useEffect(() => {
  //   const userDetail = userDetails();
  //   const employeeId = userDetail?.EmployeeId;
  //   if (employeeId) {
  //     getUsers(1, defaultPageSize, "ASC", employeeId, "");
  //   }
  // }, [userDetail?.EmployeeId, 1, defaultPageSize]);
  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  const onSubmit = async (data) => {
    try {
      setloader(true); // Set loading to true during submission
      const payload = {
        ...selectedEmployees,
      };

      // Assuming dispatch is asynchronous, you can wait for it to complete using await
      const res = await new Promise((resolve) => {
        dispatch(addNewAuditPersons(payload, resolve));
      });

      if (res && res?.IsSuccessful) {
        getUsers(1, defaultPageSize, "ASC", parseInt(userDetail?.EmployeeId)); // Fetch updated data
        Toaster.success(res?.Data[0]?.Message);
        setValue("categoryCode", null);
        setSelectedEmployees({
          ...selectedEmployees,
          employeeCodeList: [], // Clear the employeeCodeList
        });
      }
    } catch (error) {
      setloader(false); // Set loading to false in case of an error
      Toaster.error(error?.Res?.data?.ErrorMessage);
    } finally {
      setloader(false); // Ensure loading is set to false even if an error occurs
    }
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1300 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
    props.api.sizeColumnsToFit();
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };
  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : auditTrailReducer?.data
          ? auditTrailReducer?.data
          : [];
    return returnExcelColumn(Audit_TRAIL_EXCEL, tempArr);
  };

  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={'Audit Trail List'}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  // const onFloatingFilterChanged = (value) => {
  //   setTimeout(() => {
  //     if (auditTrailReducer.length !== 0) {
  //       setState((prevState) => ({
  //         ...prevState,
  //         noData: searchNocontentFilter(value, prevState.noData),
  //       }));
  //     }
  //   }, 500);
  // };
  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleViewPopup = () => {
      setOldValue(props?.data?.OldValue);
      setNewValue(props?.data?.NewValue);
      // setShowPopup(true);
      // setDeletedID(props?.data?.Id);
      setOpen(true);
      // alert(`Old Value: ${props.data.OldValue}\nNew Value: ${props.data.NewValue}`);
    };
    return (
      <div>
        {/* {permissionsAudit?.Delete && ( */}
        <button
          title="View"
          className="View hl-view-icon"
          type="button"
          onClick={handleViewPopup}
        ></button>
        {/* )} */}
      </div>
    );
  };
  const ActionButtonRenderer = ({ data }) => {
    const handleClick = () => {
      alert(`Old Value: ${data.OldValue}\nNew Value: ${data.NewValue}`);
    };

    return <button onClick={handleClick}>Show Values</button>;
  };

  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  const checkBoxRenderer = (props) => {
    let selectedRowForPagination =
      reactLocalStorage.getObject("selectedRow").selectedRow;
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    if (selectedRowForPagination?.length > 0) {
      selectedRowForPagination.map((item) => {
        if (item.id === props.node.data.id) {
          props.node.setSelected(true);
        }
        return null;
      });
      return cellValue;
    } else {
      return cellValue;
    }
  };
  /**
  * @method effectiveDateFormatter
  * @description Renders buttons
  */
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  /**
   * @method effectiveDateFormatter
   * @description Renders buttons
   */

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    effectiveDateFormatter: effectiveDateFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    checkBoxRenderer: checkBoxRenderer,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  /**
   * @method statusButtonFormatter
   * @description Renders buttons
   */

  const handleDeleteAuditPerson = (auditId) => {
    setloader(true);

    deleteAuditPerson(auditId, (error, response) => {
      setloader(false); // Set loader to false once the delete request is complete
      if (error) {
        Toaster.error(error.response?.data?.ErrorMessage);
      } else {
        Toaster.success(response?.data?.Data[0]?.Message);
        // Fetch updated data after deletion
        getUsers(1, defaultPageSize, "ASC", userDetail?.EmployeeId);
      }
    });
  };
  const onPopupConfirm = () => {
    // setIsModalOpen(false);
    setShowPopup(false);
    handleDeleteAuditPerson(deletedId);
  };
  const closePopUp = () => {
    setShowPopup(false);
  };

  const handleCloseDrawer = () => {
    setOpen(false); // Close the drawer
    // resetForm(); // Call resetForm function
  };
  const cancel = () => {
    setOpen(false);
    // resetForm()
  };

  let title = '';
  if (oldData && newData) {
    title = 'Old Value and New Value';
  } else if (oldData) {
    title = 'Old Value';
  } else if (newData) {
    title = 'New Value';
  }
  return (
    <>
      {loader && <LoaderCustom customClass="simulation-Loader hl-loader-fixed" />}
      {showPopup && (
        <PopupMsgWrapper
          isOpen={showPopup}
          closePopUp={closePopUp}
          confirmPopup={onPopupConfirm}
          message={`Are you sure you want to delete this item?`}
        />
      )}
      <>
        <Row className="ag-grid-react">
          <Col>
            <div
              className={`ag-theme-material ${state.isLoader && "max-loader-height"
                }`}
            >
              {state.noData && (
                <NoContentFound
                  title={EMPTY_DATA}
                  customClassName="no-content-found"
                />
              )}
              <Row className={`filter-row-large`}>
                <Col md="12" className="mb-3 d-flex justify-content-end">
                  <div className="d-flex justify-content-end bd-highlight w100">
                    <>
                      
                        {/* <button
                          className="user-btn mr5"
                          title="Add"
                          onClick={() => {
                            setOpen(true);
                          }}
                        >
                          <div className={"plus mr-0"}></div>
                        </button> */}
                            <>
                        {/* {permissionsAudit?.Download && ( */}
                        <ExcelFile
                          filename={'Audit Trail List'}
                          fileExtension={".xls"}
                          element={
                            <button
                              title={`Download ${state.dataCount === 0
                                ? "All"
                                : "(" + state.dataCount + ")"
                                }`}
                              type="button"
                              className={"user-btn mr5 Tour_List_Download"}
                            >
                              <div className="download mr-1"></div>
                              {`${state.dataCount === 0
                                ? "All"
                                : "(" + state.dataCount + ")"
                                }`}
                            </button>
                          }
                        >
                          {onBtExport()}
                        </ExcelFile>
                        {/* )} */}

                      </>
                      <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                        <div className="refresh mr-0"></div>
                      </button>
                    </>
                  </div>
                </Col>
              </Row>
              {state.isLoader ? (
                <LoaderCustom customClass="loader-center" />
              ) : (
                <AgGridReact
                  defaultColDef={defaultColDef}
                  floatingFilter={true}
                  domLayout="autoHeight"
                  // columnDefs={c}
                  rowData={
                    state.showExtraData && auditTrailReducer
                      ? [
                        ...setLoremIpsum(auditTrailReducer?.data[0]),
                        ...auditTrailReducer?.data,
                      ]
                      : auditTrailReducer?.data
                  }
                  pagination={true}
                  paginationPageSize={defaultPageSize}
                  onGridReady={onGridReady}
                  gridOptions={gridOptions}
                  noRowsOverlayComponent={"customNoRowsOverlay"}
                  noRowsOverlayComponentParams={{
                    title: EMPTY_DATA,
                    imagClass: "imagClass",
                  }}
                  rowSelection={"multiple"}
                  suppressRowClickSelection={true}
                  onSelectionChanged={onRowSelect}
                  // onFilterModified={onFloatingFilterChanged}
                  frameworkComponents={frameworkComponents}
                >
                  <AgGridColumn
                    cellClass="has-checkbox"
                    field="EmployeeCode"
                    floatingFilter={true}
                    sortable={true}
                    unSortIcon={true}
                    headerName="Employee Code"
                  ></AgGridColumn>

                  <AgGridColumn
                    field="EmployeeName"
                    floatingFilter={true}
                    headerName="Employee Name"

                  // cellRenderer={checkBoxRenderer}
                  ></AgGridColumn>
                  <AgGridColumn
                    field="GroupingKey"
                    floatingFilter={true}
                    headerName="TransactionID"

                  // cellRenderer={checkBoxRenderer}
                  ></AgGridColumn>
                   <AgGridColumn
                    field="TableName"
                    floatingFilter={true}
                    headerName="Section"

                  // cellRenderer={checkBoxRenderer}
                  ></AgGridColumn>
                  <AgGridColumn
                    field="ChangedDate"
                    filter="agDateColumnFilter"
                    headerName="Change Date"
                    cellRenderer={"effectiveDateFormatter"}
                    filterParams={{
                      comparator: (filterDate, cellValue) => {
                        // Parse the cellValue string to a Date object
                        const cellDate = new Date(cellValue);
                        // Remove the time part from both dates to only compare the date part
                        const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                        const cellDateOnly = cellDate.setHours(0, 0, 0, 0);

                        if (cellDateOnly < filterDateOnly) return -1;
                        if (cellDateOnly > filterDateOnly) return 1;
                        return 0;
                      },
                      inRangeInclusive: true, // Include start and end values in the range
                      filterOptions: ["equals", "inRange"],
                      browserDatePicker: true,
                      closeOnApply: true,
                      minValidYear: 2000,
                    }}
                  // cellRenderer={checkBoxRenderer}
                  ></AgGridColumn>
                  <AgGridColumn
                    field="Action"
                    floatingFilter={true}
                    headerName="Activity"

                  // cellRenderer={checkBoxRenderer}
                  ></AgGridColumn>
                  <AgGridColumn
                    headerName="Action"
                    sortable={false}
                    cellRenderer={"totalValueRenderer"}
                    type="rightAligned"
                    floatingFilter={false}
                    width={120}
                  ></AgGridColumn>
                </AgGridReact>
              )}

              {
                <PaginationWrapper
                  gridApi={state.gridApi}
                  setPage={onPageSizeChanged}
                />
              }
            </div>
          </Col>
        </Row>
        <Drawer
          open={open}
          anchor="right" // Assuming you want the drawer to open from the right side
          onClose={handleCloseDrawer} // Close the drawer when clicking outside or pressing ESC key
          size={"lg"}
        >
          <Container>
            <div className={"drawer-wrapper"}>
              <Row className="drawer-heading">
                <Col md="12">
                  <div className={"header-wrapper left"}>
                    <h3>{title}</h3>
                  </div>
                  <div onClick={cancel} className={"close-button right"}></div>
                </Col>
              </Row>
              <div className="pl-2 pr-2 mt-3">
                {oldData && (
                  <Table bordered className="hl-audittrail-tbl hl-tbl-assessment-ttl mt-3">
                    <tbody>
                      {Object.keys(oldData)?.map((key, index) => (
                        <tr key={key}>
                          <th><span>{key}</span></th>
                          <td>{Object.values(oldData)?.[index] !== null ? Object.values(oldData)?.[index].toString() : "-"}</td>
                        </tr>
                      ))}
                      {/* <tr>
                        <th><span>Approver Id</span></th>
                        <td>{oldData.ApproverProfileID || "-"}</td>
                      </tr>
                      <tr>
                        <th><span>Id</span></th>
                        <td>{oldData.Id || "-"}</td>
                      </tr>
                      <tr>
                        <th><span>Status</span></th>
                        <td>{oldData.IsActive || "-"}</td>
                      </tr>
                      <tr>
                        <th><span>Delete</span></th>
                        <td>{oldData.IsDelete || "-"}</td>
                      </tr> */}
                    </tbody>
                  </Table>
                )}

                {newData && (
                  <Table bordered className="hl-audittrail-tbl hl-tbl-assessment-ttl mt-3">
                    <tbody>
                      {/* <tr>
                        <th><span>Approver Id</span></th>
                        <td>{newData.ApproverProfileID || "-"}</td>
                      </tr> */}
                      {Object.keys(newData)?.map((key, index) => (
                        <tr key={key}>
                          <th><span>{key}</span></th>
                          <td>{Object.values(newData)?.[index] !== null ? Object.values(newData)?.[index].toString() : "-"}</td>
                        </tr>
                      ))}
                      {/* <tr>
                        <th><span>Id</span></th>
                        <td>{newData.Id || "-"}</td>
                      </tr>
                      <tr>
                        <th><span>Status</span></th>
                        <td>{newData.IsActive || "-"}</td>
                      </tr>
                      <tr>
                        <th><span>Delete</span></th>
                        <td>{newData.IsDelete || "-"}</td>
                      </tr> */}
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </Container>
        </Drawer>
      </>
    </>
  );
};
export default AuditTrail;
